import React from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "store";
import styled from "styled-components";
import { AudienceParams } from "modules/Campaigns/Audience/Components/AudienceHeader";
import EditItemName from "modules/Common/Components/EditItemName";
import SwitchItem from "modules/Common/Components/SwitchItem";
import { getQueryParam } from "utils";
import { updateNameAssetWithoutCampaign } from "../actions";
import StickyHeader from ".././../../Common/Components/StickyHeader";
import StickyHeaderContentWithBackButton from "../../Shared/StickyHeaderContentWithBackButton";
import AssetsWithoutCampaignsTab from "./AssetsWithoutCampaignTab";

interface Props { }

const AssetWithoutCampaignHeader = (props: Props) => {
  const { tab } = useParams<AudienceParams>();
  const assetId = getQueryParam("asset_id");
  const assetName = useSelector((state: RootState) => state.assetWithoutCampaignDetails.assetName);
  const loading: boolean = useSelector((state: RootState) => state.assetWithoutCampaignDetails.loading);
  const updateNameLoading: boolean = useSelector(
    (state: RootState) => state.assetWithoutCampaignDetails.updateName.loading
  );

  const updateNameHandler = (value: string) => {
    updateNameAssetWithoutCampaign(value, assetId);
  };

  const isDashboard = tab === undefined || tab === "/";

  return (
    <Wrapper>
      <Row gutter={24}>
        <Col className="gutter-row mb-2" span="15">
          <EditItemName
            itemTitle={"Digest"}
            itemName={assetName}
            loading={loading || updateNameLoading}
            hideBack={false}
            submitHandler={updateNameHandler}
            nonEditable={false}
          />
        </Col>
        {isDashboard ? (
          <Col className="d-flex align-items-center switch-button-col">
            <SwitchItem assetId={12} />
          </Col>
        ) : null}
      </Row>
      <StickyHeader>
        <StickyHeaderContentWithBackButton
          firstColumnSpan={11}
          secondColumnSpan={12}
          itemTitle={"Digest"}
          itemName={assetName}
          loading={loading || updateNameLoading}
          hideBack={false}
          editNameSubmitHandler={updateNameHandler}
          nonEditable={false}
          fieldName="Asset name"
        >
          <AssetsWithoutCampaignsTab />
        </StickyHeaderContentWithBackButton>
      </StickyHeader>
    </Wrapper>
  );
};

export default AssetWithoutCampaignHeader;

const Wrapper = styled.div`
  .switch-button-col {
    padding-left: 24px;
    padding-right: 0px;
  }
`;
